import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import TextFieldsIcon from '@mui/icons-material/TextFields';

import { throttle } from '@src/helpers/throttle';
import styles from '@src/components/CampaignLanding/TextCollector.module.less';

const MAX_CHARACTERS = 5000;

const TextCollector = ({
  value,
  onChange,
  required = true,
  label = 'Write your response',
  description = '',
  placeholder = 'Share your experience in your own words...'
}) => {
  const [isTouched, setIsTouched] = useState(false);
  const textValue = value?.textContent || '';
  const characterCount = textValue.length;
  const isValid = !required || textValue.trim().length > 0;

  const handleChange = useCallback(
    throttle((newValue) => {
      onChange({
        textContent: newValue
      });
    }, 300),
    [onChange]
  );

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length <= MAX_CHARACTERS) {
      handleChange(newValue);
    }
  };

  const handleBlur = () => {
    setIsTouched(true);
  };

  const showError = required && isTouched && !isValid;

  return (
    <Box className={styles.vpTextCollectorContainer}>
      <Box className={styles.vpHeader}>
        <TextFieldsIcon fontSize="small" color="primary" />
        <Typography variant="subtitle1" fontWeight={600} className={styles.vpLabel}>
          {label}
          {required && <span className={styles.vpRequiredLabel}>*</span>}
        </Typography>
      </Box>

      {description && (
        <section className={styles.vpDescription}>{description}</section>
      )}

      <TextField
        multiline
        rows={5}
        fullWidth
        placeholder={placeholder}
        value={textValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        error={showError}
        className={styles.vpTextField}
        inputProps={{
          maxLength: MAX_CHARACTERS
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px'
          }
        }}
      />

      <Box className={styles.vpFooter}>
        {showError && (
          <Typography variant="caption" color="error">
            Please write your testimonial
          </Typography>
        )}
        <Typography
          variant="caption"
          color={characterCount >= MAX_CHARACTERS ? 'error' : 'text.secondary'}
          className={styles.vpCharacterCount}
        >
          {characterCount.toLocaleString()} / {MAX_CHARACTERS.toLocaleString()} characters
        </Typography>
      </Box>
    </Box>
  );
};

TextCollector.propTypes = {
  value: PropTypes.shape({
    textContent: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string
};

export default TextCollector;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/TextCollector.jsx